module.exports = __webpack_public_path__ + "img/industri_paavirkning_utslipp.940425ab.jpg";